import "../flow.css";
import { page } from "../page-copy";
import { revealHostProps } from "../reveal-host";
import Adapters from "./Adapters";
import Closing from "./Closing";
import LiveDemos from "./LiveDemos";
import Nav from "./Nav";
import TypeIn from "./TypeIn";
import WhatsNext from "./WhatsNext";
import Why, { Pivot } from "./Why";

const TYPE_STEP = 0.01;
const TYPE_FADE = 0.08;

/** Staggered TypeIn start times (seconds). */
const TITLE_PRIMARY_AT = 0.02;
const TITLE_SECONDARY_AT = 0.18;
const WOW_AT = 0.32;

/** After wow TypeIn finishes. */
const AFTER_TYPE =
  WOW_AT + Math.max(page.wow.length - 1, 0) * TYPE_STEP + TYPE_FADE + 0.06;
const STEP = 0.18;

const intro0 = AFTER_TYPE;
const intro1 = AFTER_TYPE + STEP;
const whyStart = AFTER_TYPE + 2 * STEP;
const pivotDelay = whyStart + page.why.length * STEP;
const liveDelay = pivotDelay + STEP;
const adaptersDelay = liveDelay + STEP;
const nextDelay = adaptersDelay + STEP;
const closeDelay = nextDelay + STEP;

export default function HowItWorks() {
  const pitch0 = revealHostProps(intro0);
  const pitch1 = revealHostProps(intro1);
  return (
    <>
      <Nav />
      <main className="how-it-works">
        <header className="how-hero">
          <h1 className="how-title">
            <span className="how-title-primary">
              <TypeIn text={page.title.primary} delay={TITLE_PRIMARY_AT} />
            </span>{" "}
            <span className="how-title-secondary">
              <TypeIn text={page.title.secondary} delay={TITLE_SECONDARY_AT} />
            </span>
          </h1>
          <p className="how-wow">
            <TypeIn text={page.wow} delay={WOW_AT} />
          </p>
          <div
            className={pitch0.className}
            style={pitch0.style}
            onAnimationEnd={pitch0.onAnimationEnd}
          >
            <p className="how-pitch">{page.intro[0]}</p>
          </div>
          <div
            className={pitch1.className}
            style={pitch1.style}
            onAnimationEnd={pitch1.onAnimationEnd}
          >
            <p className="how-pitch">{page.intro[1]}</p>
          </div>
        </header>

        <Why start={whyStart} step={STEP} />
        <Pivot delay={pivotDelay} />
        <LiveDemos delay={liveDelay} />
        <Adapters delay={adaptersDelay} />
        <WhatsNext delay={nextDelay} />
        <Closing delay={closeDelay} />
      </main>
    </>
  );
}
